'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createIconComponent = require('./utils/createIconComponent');

var _createIconComponent2 = _interopRequireDefault(_createIconComponent);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconDrop = (0, _createIconComponent2.default)({ fillContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M12.842.447a1.036 1.036 0 0 0-1.684 0C11.086.558 4 11.735 4 15.986a8 8 0 0 0 16 0C20 11.736 12.914.558 12.842.447zM12 21.236a5.256 5.256 0 0 1-5.25-5.25.75.75 0 0 1 1.5 0 3.755 3.755 0 0 0 3.75 3.75.75.75 0 1 1 0 1.5z' })
  ), lightContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M12 24.052c-4.411 0-8-3.589-8-8C4 12.566 8.998 4 11.146.479a1 1 0 0 1 1.708.001C15.003 3.998 20 12.561 20 16.052c0 4.411-3.589 8-8 8zM12 1c-1.643 2.692-7 11.73-7 15.053 0 3.86 3.14 7 7 7s7-3.14 7-7C19 12.724 13.642 3.689 12 1z' }),
    _react2.default.createElement('path', { d: 'M11.988 21.021a4.969 4.969 0 0 1-3.515-1.445.493.493 0 0 1-.148-.353.496.496 0 0 1 .5-.502c.133 0 .258.052.352.145a3.974 3.974 0 0 0 2.812 1.155h.012a.5.5 0 0 1 .001 1H11.988z' })
  ), regularContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M11.75 23.647c-4.135 0-7.5-3.365-7.5-7.5 0-5.015 4.365-12.306 6.242-15.207a1.487 1.487 0 0 1 1.259-.687 1.489 1.489 0 0 1 1.258.69c1.875 2.899 6.24 10.189 6.24 15.204.001 4.136-3.364 7.5-7.499 7.5zm0-21.889c-1.415 2.188-6 9.65-6 14.39 0 3.308 2.692 6 6 6s6-2.692 6-6c0-4.744-4.59-12.21-6-14.39z' }),
    _react2.default.createElement('path', { d: 'M11.75 20.65a4.505 4.505 0 0 1-4.5-4.5.751.751 0 0 1 1.5-.002 3.005 3.005 0 0 0 3 3.003.75.75 0 0 1 0 1.499z' })
  ), height: undefined, width: undefined, viewBox: "0 0 24 24" });
IconDrop.displayName = 'IconDrop';
exports.default = IconDrop;